import Menu from './Menu';
new Menu();